module.exports = __webpack_public_path__ + "static/media/slider_arrow_left.f2bd6cac.svg";